/**
 * Supported file type categories
 */
export type FileType =
  | 'image'
  | 'pdf'
  | 'document'
  | 'data'
  | 'video'
  | 'audio'
  | 'other'

/**
 * Determine file type category from MIME type
 */
export function getFileTypeFromMime(mimeType: string): FileType {
  if (mimeType.startsWith('image/')) return 'image'
  if (mimeType === 'application/pdf') return 'pdf'
  if (mimeType.startsWith('video/')) return 'video'
  if (mimeType.startsWith('audio/')) return 'audio'
  if (
    mimeType.startsWith('text/') ||
    mimeType.includes('document') ||
    mimeType.includes('word')
  ) {
    return 'document'
  }
  if (
    mimeType.includes('csv') ||
    mimeType.includes('excel') ||
    mimeType.includes('spreadsheet') ||
    mimeType === 'application/json'
  ) {
    return 'data'
  }
  return 'other'
}

/**
 * Get Material Design Icon name for file type
 */
export function getFileIcon(fileType: FileType): string {
  const icons: Record<FileType, string> = {
    image: 'mdi:image',
    pdf: 'mdi:file-pdf-box',
    document: 'mdi:file-document',
    data: 'mdi:file-table',
    video: 'mdi:video',
    audio: 'mdi:music',
    other: 'mdi:file',
  }
  return icons[fileType]
}

/**
 * Get Tailwind CSS classes for file icon background and text color
 */
export function getFileIconBg(fileType: FileType): string {
  const colors: Record<FileType, string> = {
    image: 'bg-purple-100 text-purple-600',
    pdf: 'bg-red-100 text-red-600',
    document: 'bg-blue-100 text-blue-600',
    data: 'bg-green-100 text-green-600',
    video: 'bg-orange-100 text-orange-600',
    audio: 'bg-pink-100 text-pink-600',
    other: 'bg-gray-100 text-gray-600',
  }
  return colors[fileType]
}
